export const routes = {
    auth: '/',
    contacts: '/contacts',
    main: '/main',
    planning: '/planning',
    rewards: '/rewards',
}